/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-betting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.47
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentHighscoreSlot
 */
export interface TournamentHighscoreSlot {
    /**
     * 
     * @type {string}
     * @memberof TournamentHighscoreSlot
     */
    tournamentRoundId: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentHighscoreSlot
     */
    absolutePos: number;
}

/**
 * Check if a given object implements the TournamentHighscoreSlot interface.
 */
export function instanceOfTournamentHighscoreSlot(value: object): value is TournamentHighscoreSlot {
    if (!('tournamentRoundId' in value) || value['tournamentRoundId'] === undefined) return false;
    if (!('absolutePos' in value) || value['absolutePos'] === undefined) return false;
    return true;
}

export function TournamentHighscoreSlotFromJSON(json: any): TournamentHighscoreSlot {
    return TournamentHighscoreSlotFromJSONTyped(json, false);
}

export function TournamentHighscoreSlotFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentHighscoreSlot {
    if (json == null) {
        return json;
    }
    return {
        
        'tournamentRoundId': json['tournamentRoundId'],
        'absolutePos': json['absolutePos'],
    };
}

export function TournamentHighscoreSlotToJSON(value?: TournamentHighscoreSlot | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'tournamentRoundId': value['tournamentRoundId'],
        'absolutePos': value['absolutePos'],
    };
}

